import { DateTime } from 'luxon';

/**
 * Generates a timestamp string for filenames
 * @returns Timestamp in format yyyy-MM-dd_HH-mm-ss
 */
export const getTimestamp = (): string => {
  return DateTime.now().toFormat('yyyy-MM-dd_HH-mm-ss');
};

/**
 * Builds a filename with timestamp
 * @param prefix - File prefix (e.g., 'background_image', 'preview_Selected')
 * @param extension - File extension (e.g., 'png', 'jpg')
 * @param timestamp - Optional timestamp (defaults to current time)
 * @returns Filename with timestamp
 */
export const buildFilename = (prefix: string, extension: string, timestamp?: string): string => {
  const ts = timestamp || getTimestamp();
  return `${prefix}_${ts}.${extension}`;
};

/**
 * Builds an asset filename with timestamp
 * @param type - Asset type (e.g., 'background_image', 'logo')
 * @param extension - File extension
 * @param timestamp - Optional timestamp
 * @returns Asset filename with timestamp
 */
export const buildAssetFilename = (type: string, extension: string, timestamp?: string): string => {
  return buildFilename(type.toLowerCase(), extension, timestamp);
};

/**
 * Formats file size in bytes to human-readable format
 * @param sizeInBytes - File size in bytes
 * @returns Formatted size string (KB for < 1MB, MB for >= 1MB)
 */
export const formatFileSize = (sizeInBytes: number): string => {
  const sizeInKB = sizeInBytes / 1024;
  const sizeInMB = sizeInKB / 1024;

  if (sizeInMB >= 1) {
    return `${sizeInMB.toFixed(2)}MB`;
  }

  return `${Math.round(sizeInKB)}KB`;
};
